module.exports = __webpack_public_path__ + "static/media/opacity-c.64c4e1fb.png";